import * as React from "react";
import type { SVGProps } from "react";
const SvgPigBank = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.33 10H20v.01c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-.67c-.34.7-.79 1.34-1.33 1.9v1.6a2.5 2.5 0 0 1-4.95.5h-4.1a2.5 2.5 0 0 1-4.95-.5v-1.6c-2.56-2.6-2.69-6.8-.22-9.56-.39-.53-.65-1.15-.74-1.82a3.98 3.98 0 0 1 .79-2.96 3.96 3.96 0 0 1 2.65-1.53c1.06-.15 2.11.14 2.96.79C10.45 3.6 11 4.78 11 6h.2l4.25-2.83c.31-.2.71-.22 1.03-.05.33.17.53.51.53.88v3.26c.99.69 1.8 1.64 2.32 2.74M8.21 4.41c-.87-.67-2.13-.5-2.8.37h.01c-.33.43-.47.95-.4 1.48.04.29.14.56.29.8A6.95 6.95 0 0 1 8.99 6c0-.61-.28-1.2-.78-1.59m9.51 10.26c.14-.4.52-.67.94-.67H20l.02.01v-2h-1.34c-.42 0-.8-.27-.94-.67a5.04 5.04 0 0 0-2.22-2.67c-.31-.18-.5-.51-.5-.87V5.86l-2.95 1.96c-.16.11-.35.17-.55.17h-2.5c-1.42 0-2.78.61-3.73 1.67a5.01 5.01 0 0 0 .4 7.06c.21.19.33.47.33.75v2.03c0 .28.22.5.5.5s.5-.22.5-.5v-.58c0-.29.12-.57.35-.76.22-.19.52-.27.81-.22.203.036.396.046.598.057q.113.005.232.013h4c.28.01.55-.02.83-.07.06-.01.11-.01.17-.01.24 0 .47.09.65.24.22.19.35.47.35.76v.58c0 .28.22.5.5.5s.5-.22.5-.5v-2.03c0-.29.12-.56.33-.75a5.1 5.1 0 0 0 1.38-2.06M14 11.02c0-.56.45-1.01 1-1.01a1.005 1.005 0 0 1 0 2.01c-.55 0-1-.44-1-1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPigBank;
